import React from "react";
import connect from "Shared/connect";
import * as styles from "./base.scss";
import { translate } from "Shared/translate";
export const getInitialsForProfile = (fullName) => {
    return fullName
        .split(" ")
        .map((word, index) => (index < 2 ? word.charAt(0) : ""))
        .join("")
        .toUpperCase();
};
export const isSubCustomer = (currentUser) => {
    return (currentUser.fullName.startsWith(currentUser.customerId) &&
        currentUser.fullName.replace(currentUser.customerId, "").length > 0);
};
const Profile = (prop) => {
    const IsSubCustomer = isSubCustomer(prop.currentUser);
    const Initials = IsSubCustomer
        ? getInitialsForProfile(prop.currentUser.companyName)
        : getInitialsForProfile(prop.currentUser.fullName);
    const FullName = prop.currentUser.isSupplierSalesman
        ? prop.currentUser.fullName
        : prop.currentUser.companyName;
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.profileCircle }, Initials),
        React.createElement("div", { className: styles.fullName }, FullName),
        React.createElement("div", { className: styles.customerId }, prop.currentUser.customerId),
        prop.currentUser.isSupplierSalesman && (React.createElement("div", { className: styles.specialUserTypeInfo },
            React.createElement("span", { className: styles.userType },
                " ",
                translate("/SiteLayout/RightMenu/Profile/ChosenCustomer")),
            React.createElement("span", { className: styles.userInfo }, prop.currentUser.supplierSalesmanInfo))),
        !prop.currentUser.isSupplierSalesman && IsSubCustomer && (React.createElement("div", { className: styles.specialUserTypeInfo },
            React.createElement("span", { className: styles.userType },
                " ",
                translate("/SiteLayout/RightMenu/Profile/SubCustomer")),
            React.createElement("span", { className: styles.userInfo }, prop.currentUser.fullName)))));
};
export default connect((state) => ({
    currentUser: state.currentUser,
}))(Profile);
